<script setup>
  import { ref } from "vue";
  import {
    addDocument,
    couponRef,
  } from "@/firebase/firebase";

  const expire = ref(null);
  const isSuccess = ref(false);

  /**
   * バリデーションチェック
   */
  const validate = function () {
    if (!expire.value) {
      return false;
    }
    return true;
  };

  /**
   * 登録処理
   */
  const submit = async function () {
    if (!validate()) return;

    const code = generateCode()
    console.log("code:" + code);
    try {
      await addDocument(couponRef, {
        coupon_code: code,
        expire: expire.value,
        used: false
      });

      isSuccess.value = true;
    } catch (e) {
      console.log("Error adding document:" + e);
    }
  };

  const generateCode = function () {
    var min = 10000000000;
    var max = 19999999999;
    var NUM = Math.floor(Math.random() * (max + 1 - min)) + min;
    var NUM2 = ('' + NUM).slice(-10);
    return NUM2;
  }

</script>

<template>
  <div class="mt-13 mx-auto">
    <v-snackbar v-model="isSuccess" :timeout="1000" location="center">
      トークン発行しました！

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="isVisible = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-card class="mx-auto px-6 py-8 ms-2 me-2">
      <v-form ref="form" class="mb-12" fast-fail @submit.prevent>
        <div class="text-caption mt-5 mx-auto">
          クーポン有効期限
        </div>
        <v-text-field v-model.number="expire" type="number"></v-text-field>

        <v-btn block type="submit" color="blue" class="mt-5" @click="submit();">トークン発行</v-btn>


      </v-form>
    </v-card>

  </div>
</template>
